module.exports = __webpack_public_path__ + "static/img/bg_gerenzx@2x.403eb301.png";